import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { GetAdHocInvoiceApprovalTID } from '../AdHocInvoiceApproval';
export const useRetryAdHocPayment = ()=>{
    const { api } = useStoreActions();
    const { t } = useLocaleKeys();
    const { AdHocInvoiceApprovalTestIds } = GetAdHocInvoiceApprovalTID();
    const { mutate, isPending } = useMutationState({
        mutationFn: (param)=>{
            let { invoiceId, fundingSourceId } = param;
            return api.invoice.retryAdHocPayment({
                invoiceId,
                fundingSourceId
            });
        },
        toasts: {
            errorMessage: t.adHocInvoiceApproval.approveCta.approveError(),
            errorTestId: AdHocInvoiceApprovalTestIds.ApproveError()
        }
    });
    return {
        retryAdHocPayment: mutate,
        isPending
    };
};
